import { emailRegex } from '@/utils/regex/inputRegex';

export const validateEmpty = (value: string, field: string): string | undefined => {
  if (value.trim().replace(/ /g, '') == '') {
    return `${field} wajib diisi`;
  }
  return undefined;
};

export const validateNotSelected = <T>(value: T, field: string): string | undefined => {
  if (value == null || value == undefined) {
    return `${field} wajib dipilih`;
  }
  return undefined;
};

export const validatePhoneNumber = (phoneNumber: string): string | undefined => {
  if (!phoneNumber.startsWith('8')) {
    return 'Pastikan nomor handphone yang Anda masukkan sudah benar';
  } else if (phoneNumber.length < 9 || phoneNumber.length > 15) {
    return 'Harap diisi dengan angka berjumlah 9-15 karakter';
  }
  return undefined;
};

export const validateEmail = (email: string): string | undefined => {
  if (validateEmpty(email, 'Email')) {
    return validateEmpty(email, 'Email');
  }
  else if (!emailRegex.test(email)) {
    return 'Pastikan email yang Anda ketik sudah benar';
  }
};

export const validatePhoneNumberOffice = (phoneNumber: string): string | undefined => {
  if (!phoneNumber.startsWith('8') && !phoneNumber.startsWith('2')) {
    return 'Nomor Telepon harus diawali dengan 8 atau 2';
  } else if (phoneNumber.length < 7 || phoneNumber.length > 15) {
    return 'Harap diisi dengan angka berjumlah 7-15 karakter';
  }

  return undefined;
};
